module.exports = __webpack_public_path__ + "static/media/customer-bercos.c5ae5a53.png";